import Button from "@components/Button/Button";
import { ActionType, ButtonSize } from "@components/Button/utils/types";
import useSendDataToGTM from "@features/analytics/hooks/useSendDataToGTM";
import { useWindowSize } from "@hooks/useWindowSize";
import { SHARE_LINKS_LIST } from "@routes/Newsletter/DecodingAsia/components/ShareLinks/utils/constants";
import { cn } from "@util/helpers";

type ShareLinksProps = {
  /** Common classes for the component */
  className?: string;
};

/** The share link buttons for the Decoding Asia newsletter. */
const ShareLinks = ({ className }: ShareLinksProps): React.ReactElement => {
  const { isScreenLG } = useWindowSize();
  const sendDataToGTM = useSendDataToGTM();

  const handleShare = (gaEventLabel: string) => {
    sendDataToGTM({
      event: "custom_event",
      eventCategory: "share",
      eventAction: "click",
      eventLabel: gaEventLabel,
    });
  };

  return (
    <div
      data-testid="share-links-component"
      className={cn(
        "mb-6 flex w-full flex-col items-center gap-4 lg:flex-row xl:w-2/3",
        className
      )}
    >
      <p className="mb-0 text-center font-poppins text-base font-normal leading-normal text-gray-850 lg:text-left">
        Share this Newsletter
      </p>

      <div className="flex flex-wrap justify-center gap-4 lg:gap-2">
        {SHARE_LINKS_LIST.map(({ whichSocialMedia, icon, gaEventLabel }) => {
          return (
            <div key={whichSocialMedia}>
              <Button
                icon={icon}
                whichSocialMedia={whichSocialMedia}
                actionType={ActionType.shareButton}
                className="m-0 aspect-square w-full items-center justify-center rounded-full border border-gray-195 bg-white text-base hover:bg-gray-250"
                imgAlt="Sign up for Decoding Asia newsletter here"
                title="Sign up for Decoding Asia newsletter here"
                shareUrl="https://www.businesstimes.com.sg/newsletters/sign-up/decoding-asia" // TODO: Use a shortened URL
                buttonSize={isScreenLG ? ButtonSize.small : ButtonSize.large}
                iconSize={isScreenLG ? 24 : 34}
                callback={() => {
                  handleShare(gaEventLabel);
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ShareLinks;
